import React, { useEffect, useState } from "react";
import DashboardLayout from "../../components/layout/DashboardLayout";
import styles from "../../styles/pages/alert-system/index.module.sass";
import TrackedSignals from "../../components/alert-system/TrackedSignals";
import { useDispatch, useSelector } from "react-redux";
import {
  getAlertStatus,
  getPreviousEmails,
  getTrackedSignal,
} from "../../redux/alert-system/actions";
import PreviousEmails from "../../components/tables/PreviousEmails";
import AlertSystem2 from "../../components/alert-system/AlertSystem2";
import { useParams } from "react-router";
import usePageTitle from "../../hooks/usePageTitle";
import PageHeader from "../../ui/PageHeader";
import AlertStrategy from "../../components/alert-system/AlertStrategy";
import { useNavigate } from "react-router-dom";

const AlertSystem = () => {
  const dispatch = useDispatch();
  const {
    main: { userData },
    alertSystem: {
      trackedSignals,
      loading,
      error,
      alertStatus,
      previousEmails,
    },
    profile: { profileData },
  } = useSelector((state) => state);

  const { section } = useParams();

  const [showDemo, setShowDemo] = useState(true);
  usePageTitle("Alert System");

  const navigate = useNavigate();

  useEffect(() => {
    if (userData?.["cognito:username"]) {
      if (!section && !alertStatus?.STATUS && !loading) {
        dispatch(
          getAlertStatus(
            userData?.["cognito:username"],
            userData?.["custom:custom_username"],
          ),
        );
      }
      if (section === "tracked-signals") {
        dispatch(
          getTrackedSignal(
            userData?.["cognito:username"],
            userData?.["custom:custom_username"],
          ),
        );
      }
      if (section === "previous-emails") {
        dispatch(
          getPreviousEmails(
            userData?.["cognito:username"],
            userData?.["custom:custom_username"],
          ),
        );
      }
    }
  }, [userData, section, dispatch]);

  return (
    <DashboardLayout
      alertSystem
      error={error}
      loading={loading}
      hasDemo={showDemo}
    >
      <div className={styles.wrapper}>
        <div className={styles.main}>
          <PageHeader
            // title={
            //   !section
            //     ? "Alert System Configuration"
            //     : section === "strategy-alerts"
            //       ? "Custom Strategy Alerts"
            //       : "Alert system emails"
            // }
            title="Alert System"
            service="alert"
          />
          <div className={styles.tabs}>
            <div
              className={`${styles.tab} ${!section ? styles.active : ""}`}
              onClick={() => navigate("/alert-system")}
            >
              Alert Setup
            </div>

            <div
                className={`${styles.tab} ${section === "strategy-alerts" ? styles.active : ""}`}
                onClick={() => navigate("/alert-system/strategy-alerts")}
            >
              Strategies & Scheduling
            </div>
          </div>

          {!section && (
            <AlertSystem2
              data={alertStatus}
              showDemo={() => setShowDemo(true)}
              hideDemo={() => setShowDemo(false)}
            />
          )}
          {section === "strategy-alerts" && <AlertStrategy />}
          {/*{section === "tracked-signals" && (*/}
          {/*  <TrackedSignals data={trackedSignals?.LIST_SIGNALS} />*/}
          {/*)}*/}
          {/*{section === "previous-emails" && (*/}
          {/*  <PreviousEmails data={previousEmails?.Items} />*/}
          {/*)}*/}
        </div>
      </div>
    </DashboardLayout>
  );
};

export default AlertSystem;
